// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css - Glassmorphism Dark Theme */

.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 2rem;
}

.login-panel {
  width: 100%;
  max-width: 450px;
  text-align: center;
  position: relative;
  z-index: 10;
}

.login-icon {
  margin: 0 auto 1.5rem;
  font-size: 2rem;
}

.login-title {
  margin-bottom: 0.5rem;
  font-size: clamp(2rem, 4vw, 2.75rem);
}

.login-subtitle {
  color: rgba(226, 232, 240, 0.7);
  font-size: 1.05rem;
  margin-bottom: 2rem;
  font-weight: 400;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.login-button {
  width: 100%;
  padding: 1rem 1.5rem;
  font-size: 1.05rem;
  margin-top: 0.5rem;
  position: relative;
  overflow: hidden;
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.loading-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: var(--white);
  animation: spin 0.8s linear infinite;
  margin-right: 0.75rem;
  vertical-align: middle;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.login-decoration {
  margin-top: 2rem;
  animation: fadeInUp 0.8s ease-out;
}

/* Mobile responsive */
@media (max-width: 576px) {
  .login-container {
    padding: 1.5rem;
  }

  .login-panel {
    padding: 1.75rem;
  }

  .login-icon {
    width: 42px;
    height: 42px;
    font-size: 1.5rem;
  }

  .login-title {
    font-size: 2rem;
  }

  .login-subtitle {
    font-size: 0.95rem;
  }

  .login-form {
    gap: 1.25rem;
  }
}

/* Tablet */
@media (max-width: 768px) {
  .login-container {
    padding: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Login.css - Glassmorphism Dark Theme */\n\n.login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  padding: 2rem;\n}\n\n.login-panel {\n  width: 100%;\n  max-width: 450px;\n  text-align: center;\n  position: relative;\n  z-index: 10;\n}\n\n.login-icon {\n  margin: 0 auto 1.5rem;\n  font-size: 2rem;\n}\n\n.login-title {\n  margin-bottom: 0.5rem;\n  font-size: clamp(2rem, 4vw, 2.75rem);\n}\n\n.login-subtitle {\n  color: rgba(226, 232, 240, 0.7);\n  font-size: 1.05rem;\n  margin-bottom: 2rem;\n  font-weight: 400;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.login-button {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  font-size: 1.05rem;\n  margin-top: 0.5rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: var(--white);\n  animation: spin 0.8s linear infinite;\n  margin-right: 0.75rem;\n  vertical-align: middle;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.login-decoration {\n  margin-top: 2rem;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n/* Mobile responsive */\n@media (max-width: 576px) {\n  .login-container {\n    padding: 1.5rem;\n  }\n\n  .login-panel {\n    padding: 1.75rem;\n  }\n\n  .login-icon {\n    width: 42px;\n    height: 42px;\n    font-size: 1.5rem;\n  }\n\n  .login-title {\n    font-size: 2rem;\n  }\n\n  .login-subtitle {\n    font-size: 0.95rem;\n  }\n\n  .login-form {\n    gap: 1.25rem;\n  }\n}\n\n/* Tablet */\n@media (max-width: 768px) {\n  .login-container {\n    padding: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
